import { BrowserApi } from '@/openapi-clients-generated/auth';
import { onBeforeUnmount, onMounted } from 'vue';
import { serviceWorkerManager } from '../services/sw.manager';
import { addBroadcastMessageListener } from './broadcast.helpers';

export class IdleTimer {
    private static lastInteractionMs = Date.now();
    private static notifySwOnNextInteraction = false;
    private static notifyServerOnNextInteraction = false;

    private static updateUserInteractionTs = () => {
        this.lastInteractionMs = Date.now();
        if (this.notifySwOnNextInteraction) {
            serviceWorkerManager.postMessage('userActivity', undefined);
            this.notifySwOnNextInteraction = false;
        }
        if (this.notifyServerOnNextInteraction) {
            this.notifyServerNotIdle();
        }
    };

    static setup() {
        window.addEventListener('mousemove', this.updateUserInteractionTs);
        window.addEventListener('keydown', this.updateUserInteractionTs);
        window.addEventListener('scroll', this.updateUserInteractionTs);
        window.addEventListener('click', this.updateUserInteractionTs);

        addBroadcastMessageListener('setNotifySwOnNextInteraction', () => {
            this.notifySwOnNextInteraction = true;
        });
    }

    static teardown() {
        window.addEventListener('mousemove', this.updateUserInteractionTs);
        window.addEventListener('keydown', this.updateUserInteractionTs);
        window.addEventListener('scroll', this.updateUserInteractionTs);
        window.addEventListener('click', this.updateUserInteractionTs);
    }

    static notifyServerNotIdle() {
        BrowserApi.postBrowserDeidle();
    }

    static setNotifyServerNotIdleOnResume() {
        this.notifyServerOnNextInteraction = true;
    }

    static getIdleMs() {
        return Date.now() - this.lastInteractionMs;
    }
}

export function useIdleTimeout(options: { checkIntervalMs?: number; timeoutMs: number; onIdle: (idleMs: number) => void }) {
    let checkInteractionInterval: number | undefined;

    const checkLastInteractionTs = () => {
        const idleMs = IdleTimer.getIdleMs();
        if (idleMs >= options.timeoutMs) {
            options.onIdle(idleMs);
        }
    };

    onMounted(() => {
        checkInteractionInterval = window.setInterval(checkLastInteractionTs, options.checkIntervalMs ?? 10_000);
    });

    onBeforeUnmount(() => {
        if (checkInteractionInterval) clearInterval(checkInteractionInterval);
    });
}

IdleTimer.setup();
